import { Category } from 'src-ironside/repositories/category.repository';
import { Filter } from 'src-ironside/repositories/common.repository';

export function flatCategories(tree: any) {
    let flatArray: any = [];

    function flatten(node: any) {
        flatArray.push(node);
        if (node?.subcategoryList && node?.subcategoryList?.length > 0) {
            node?.subcategoryList?.forEach((child: any) => flatten(child));
        }
    }

    tree?.forEach((nodeRoot: any) => flatten(nodeRoot));

    return flatArray;
}

export function buildCategoryHierarchyRandom(categories: Category[]): Category[] {
    const hierarchy: Category[] = [];
    let currentLevel1: Category | null = null;
    let currentLevel2: Category | null = null;

    categories?.forEach((category: any) => {
        const level = category?.categoryLevelCategory;
        if (level === 1) {
            currentLevel1 = { ...category, subcategoryList: [] };
            hierarchy?.push(currentLevel1!);
            currentLevel2 = null;
        }
    });

    categories?.forEach((category) => {
        const level = category?.categoryLevelCategory;

        if (level === 2) {
            hierarchy.forEach((cate) => {
                const result = category.attachmentCategory?.[0]?.documentId === cate.id;
                if (result) {
                    cate.subcategoryList.push({ ...category, subcategoryList: [] });
                }
            });
        }
    });

    categories?.forEach((category) => {
        const level = category?.categoryLevelCategory;
        if (level === 3) {
            hierarchy.forEach((cate) => {
                cate.subcategoryList.forEach((subCate: any) => {
                    const result = category.attachmentCategory?.[0]?.documentId === subCate.id;
                    if (result) {
                        subCate.subcategoryList.push(category);
                    }
                });
            });
        }
    });

    function sortCategories(categories: Category[], currentLang?: string) {
        categories.sort((a, b) =>
            a?.nameCategory?.[currentLang ?? 'en_GB']?.localeCompare(
                b?.nameCategory?.[currentLang ?? 'en_GB']
            )
        );
        categories.forEach((category) => {
            if (category.subcategoryList?.length) {
                sortCategories(category.subcategoryList, currentLang);
            }
        });
    }

    function sortOrderCategories(categories: Category[]) {
        categories.sort((a: any, b: any) => {
            if (a?.orderCategory === null || a?.orderCategory === undefined) return 1;
            if (b?.orderCategory === null || b?.orderCategory === undefined) return -1;
            return a?.orderCategory - b?.orderCategory;
        });

        categories.forEach((category) => {
            if (category.subcategoryList?.length) {
                sortOrderCategories(category.subcategoryList);
            }
        });
    }

    sortCategories(hierarchy);
    sortOrderCategories(hierarchy);

    return hierarchy;
}

export function sortCategories(categories: Category[], currentLang?: string) {
    categories.sort((a, b) =>
        a?.nameCategory?.[currentLang ?? 'en_GB']?.localeCompare(
            b?.nameCategory?.[currentLang ?? 'en_GB']
        )
    );
    categories.forEach((category) => {
        if (category.subcategoryList?.length) {
            sortCategories(category.subcategoryList, currentLang);
        }
    });

    return categories;
}

export function getProductsInCategory(categories: Category[]): Category[] {
    return categories
        .map((el: any) => {
            if (el.subcategoryList?.length) {
                el.subcategoryList = getProductsInCategory(el.subcategoryList);
            }

            if (el?.linkProduct?.length || el.subcategoryList?.length) {
                return el;
            }

            return null;
        })
        .filter((el) => el !== null);
}

export function findCategoryByTree(code: string, tree: Category[]): any {
    for (const el of tree) {
        if (el.codeCategory === code) {
            return el;
        } else if (el.subcategoryList?.length) {
            const found = findCategoryByTree(code, el.subcategoryList);
            if (found) {
                return found;
            }
        }
    }
    return null;
}

export function findCategoryLv1ByCategories(tree: Category[], code: Category[]): Category[] {
    const treeFlat: Category[] = flatCategories(tree);
    let categories: Category[] = [];
    let uniqueIds = new Set<string>();

    function addCategory(category: Category) {
        if (!uniqueIds.has(category.id!)) {
            uniqueIds.add(category.id!);
            categories.push(category);
        }
    }

    function findCategory(category: Category) {
        if (category.categoryLevelCategory === 2 || category.categoryLevelCategory === 3) {
            const parent = treeFlat.find(
                (item) => item?.id === category?.attachmentCategory?.[0]?.documentId
            );
            if (parent) {
                addCategory(parent);
                if (parent.categoryLevelCategory === 2) {
                } else {
                    findCategory(parent);
                }
            }
        }
    }

    code?.forEach((el) => {
        if (el.categoryLevelCategory === 1) {
            addCategory(el);
        } else if (el.categoryLevelCategory === 2) {
            el.subcategoryList = [];
            addCategory(el);
            findCategory(el);
        } else if (el.categoryLevelCategory === 3) {
            el.subcategoryList = [];
            addCategory(el);
            findCategory(el);
        }
    });

    return categories;
}

export function findCategoryLv1ByIds(tree: Category[], ids: string[]): Category[] {
    const treeFlat: Category[] = flatCategories(tree);
    let categories: Category[] = [];
    let uniqueIds = new Set<string>();

    function addCategory(category: Category) {
        if (!uniqueIds.has(category.id!)) {
            uniqueIds.add(category.id!);
            categories.push(category);
        }
    }

    function findCategory(category: Category) {
        if (category.categoryLevelCategory === 2 || category.categoryLevelCategory === 3) {
            const parent = treeFlat.find(
                (item) => item?.id === category?.attachmentCategory?.[0]?.documentId
            );
            if (parent) {
                addCategory(parent);
                if (parent.categoryLevelCategory === 2) {
                } else {
                    findCategory(parent);
                }
            }
        }
    }

    ids?.forEach((id) => {
        const category = treeFlat.find((el) => el.id === id);
        if (category) {
            if (category.categoryLevelCategory === 1) {
                addCategory(category);
            } else if (category.categoryLevelCategory === 2) {
                category.subcategoryList = [];
                addCategory(category);
                findCategory(category);
            } else if (category.categoryLevelCategory === 3) {
                category.subcategoryList = [];
                addCategory(category);
                findCategory(category);
            }
        }
    });

    return categories;
}

export function getParamSearchFilters(value?: string) {
    let filters: Filter[] = [];
    const fieldNameArr = ['referenceProduct', 'longDescription', 'shortDescription'];

    fieldNameArr.forEach((field) => {
        let conditions: any[] = [];
        const regex = /^(\d+,)*\d+$/;
        const result = regex.test(value!) ? processInput(value!) ?? [] : [value];
        result.forEach((el) => {
            conditions.push({
                type: 'CONTAINS',
                value: el,
            });
        });

        if (conditions.length) {
            filters.push({
                fieldName: field,
                operator: 'OR',
                conditions: conditions,
            });
        }
    });
    return filters;
}

/* Check Value keyword Search */
export function processInput(input: string): string[] | null {
    const regex = /^(\d+[,\s]+)*\d+$/;

    if (regex.test(input)) {
        return input.split(/[,\s]+/).filter((item) => item.trim() !== '');
    } else {
        return null;
    }
}
